import { ActivatedRoute, Params, Router } from '@angular/router';
import { ServiceAdminService } from '../../Providers/service-admin.service';
import { Archive } from '../../Model/Archive';
import { raws } from '../../Model/Raws';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { TabsetComponent } from 'ngx-bootstrap';
import { Headers, RequestOptions } from '@angular/http';


/**
 * created by AHMED HAYEL
 * 
 */

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.css']
})
export class ArchiveComponent implements OnInit {
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  archives: Archive[] = [];
  raws: raws = new raws();
  numBoitier: number;

  limit: number = 200;

  constructor(private _location: Location, private route: ActivatedRoute, private service: ServiceAdminService, private router: Router) { }

  ngOnInit() {
    if (this.service.isAuthenticated == false) {
      this.router.navigate(['/error']);
    } else {
      this.route.params.subscribe((params: Params) => {
        this.numBoitier = (+params['numBoitier']);
      });     
      this.getArchives();      
    }

  }

  //=====================================
  //     Go back to the previous page
  //=====================================

  back() {
    this._location.back();
  }

  //=====================================
  //     Get all device's raw
  //=====================================

  getAllRaws() {
 
    this.service.getRaws(this.numBoitier,this.limit).subscribe(_raws => {
      this.raws.raws = _raws.raws;
      this.raws.count = _raws.count;
    });
  }

 //=====================================
      // Get archive of device form database
      //    
      //=====================================
  getArchives(){
    this.service.getArchiveOfBoitier(this.numBoitier,this.limit).subscribe(_archives => {
        this.archives = _archives;
        for (let i = 0; i < this.archives.length; i++) {
          this.archives[i].latitude = (+this.archives[i].latitude.toFixed(5));
          this.archives[i].longitude = (+this.archives[i].longitude.toFixed(5));
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-component/archive/archive.component.ts